export default __webpack_public_path__ + "static/media/wings.b94293c9.jpeg";